import { Component, Input, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { HolidayDisplayOptions } from '@app/types/translatables/time-off-v3-display.options';
import { BaseForm } from '@forms/base.form';
import { TimeOffDay } from '@models/time-off-v3/time-off-day.model';
import { TranslateService } from '@ngx-translate/core';
import moment, { Moment } from 'moment';

@Component({
    selector: 'app-holiday-form',
    templateUrl: './holiday.template.html',
})
export class HolidayForm extends BaseForm {
    @Input() set holiday(holiday: TimeOffDay) {
        this._holiday = holiday;
        // The default holiday names are stored in English and we translate them to French
        // It's a weird experience for a user to go to edit a holiday that's displaying French and find the form pre-filled with English
        // Therefore we set the name to French here upon initialization of the form
        if (this.translateService.currentLang === 'fr_CA' && this._holiday.name) {
            this._holiday.name = this.translateService.instant(
                HolidayDisplayOptions[this._holiday.name] ?? this._holiday.name
            );
        }
    }
    get holiday(): TimeOffDay {
        return this._holiday;
    }

    @ViewChild('calendar') calendar: MatCalendar<any>;

    private _holiday: TimeOffDay = new TimeOffDay();

    constructor(private translateService: TranslateService) {
        super();
    }

    goToDateInView(date?: Moment): void {
        this.calendar._goToDateInView(date ?? moment(), 'month');
    }
}
